import React from "react";
import direction from "../../../service/direction.json";
import dataPanel from "../../../service/dataPanel.json";
const SliderLab = () => {
  return (
    <div>
      <div className="form-group row text-center col-md-12 ">
        {dataPanel.pluginList.map((p, i) => (
          <div className="row col-md-2">
            <img
              classname="img"
              src={direction.ImgSlider + p.image}
              alt="سایه بان"
            ></img>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SliderLab;
